import React from "react";
import {Select} from "antd";
import {useTranslation} from "react-i18next";
//local
import {Tag} from "components/Tag";
import {LockValue} from "components/LockValue";
import {color as constColor} from "constants/color.consts";
import {IconChevronDownMini} from "components/icons";
import cn from "classnames";

const {Option} = Select;

const ActionSelect = ({
  list,
  disabled,
  iconsList,
  permissionList,
  onChange,
  label,
  color = constColor.black,
  isRelativeCustomContent,
  customContent,
  addClass,
}) => {
  const {t} = useTranslation();

  const tagIconColor = disabled ? constColor.midGray : color;

  const options = () =>
    list.map((item, i) => (
      <Option key={item} value={item} className="__uppercase fz-10 __bold">
        {permissionList[i] ? (
          <LockValue
            canPermissions={permissionList[i]}
            needLabel
            needShowModalToSubscribe
            addClassWrapper="mr-4"
          >
            {iconsList?.[i]}
            {t(item)}
          </LockValue>
        ) : (
          <React.Fragment>
            {iconsList?.[i]}
            {t(item)}
          </React.Fragment>
        )}
      </Option>
    ));

  return (
    <div
      className={cn("mini-select_wrapper", {[addClass]: !!addClass})}
      style={{position: isRelativeCustomContent && "relative"}}
    >
      <Select
        className="mini-select_select"
        bordered={false}
        disabled={disabled}
        onChange={onChange}
        suffixIcon={null}
        defaultValue={null}
        value={null}
        placeholder={
          <Tag
            text={label}
            color={tagIconColor}
            suffixIcon={<IconChevronDownMini color={tagIconColor} />}
            noBackground
            needTranslation
          />
        }
        popupClassName="mini-select_dropdown auto-width"
      >
        {options()}
      </Select>
      {customContent}
    </div>
  );
};

export default ActionSelect;
